import { useApiThumbnailsRange } from '../../../../../../../core/hooks/api/useApiThumbnailsRange';
import { useActiveStation } from '../../../../../../../core/stations/hooks/useActiveStation';
import { useStreamSegmentsRange_v2 } from '../../../hooks/segments/useStreamSegmentsQuery';

export function useLoggerRangeThumbnails() {
  const activeStation = useActiveStation();

  const { range, isLoading } = useStreamSegmentsRange_v2();
  const query = useApiThumbnailsRange(activeStation.id, range.from, range.to, {
    enabled: !isLoading && !!range.from,
  });

  return {
    thumbnails: query.data || [],
    isLoading: query.isLoading,
  };
}
